import * as React from 'react'
import { Text } from 'web-makeup/dist/design-system/styles/typography'

import { Wrapper, InnerWrapper } from './BrandDashbboardLoader.style'

const BrandDashboardLoader: React.FC = () => {
  return (
    <Wrapper>
      <InnerWrapper>
        <div>
          <div>
            <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1669963644/-design-system/icon-loader-1.svg" />
            <Text as="h3" fontSize="h5" color="black1" fontWeight="bold">
              Charging camera
            </Text>
          </div>
        </div>
        <div>
          <div>
            <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1669963644/-design-system/icon-loader-2.svg" />
            <Text as="h3" fontSize="h5" color="black1" fontWeight="bold">
              Setting up lights
            </Text>
          </div>
        </div>
        <div>
          <div>
            <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1669963644/-design-system/icon-loader-3.svg" />
            <Text as="h3" fontSize="h5" color="black1" fontWeight="bold">
              Assembling all-star creators
            </Text>
          </div>
        </div>
        <div>
          <div>
            <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1669963644/-design-system/icon-loader-4.svg" />
            <Text as="h3" fontSize="h5" color="black1" fontWeight="bold">
              Checking the mic
            </Text>
          </div>
        </div>
        <div>
          <div>
            <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1669963644/-design-system/icon-loader-5.svg" />
            <Text as="h3" fontSize="h5" color="black1" fontWeight="bold">
              Finalising script
            </Text>
          </div>
        </div>
      </InnerWrapper>
    </Wrapper>
  )
}

export default BrandDashboardLoader



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/BrandDashbboardLoader/BrandDashbboardLoader.tsx